// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2wDWC","containerItemsCenter":"Skeleton_containerItemsCenter__MQQ-K"};